<template>
    <div v-if="loading_reservista === true">
      <loading />
    </div>
    <div v-else>
      <div class="col s12 m12 no-padding doc-type-section">
        <div class="input-field col s12 m6">
          <input v-model="reservista.pf_res" id="reservista_num" type="text" class="validate">
          <label for="reservista_num">Número</label>
        </div>
        <div class="input-field col s12 m6">
          <input v-model="reservista.pf_res_emissao" v-mask="['##/##/####']" id="pf_res_emissao" ref="pf_res_emissao" type="text" class="validate">
          <label for="reservista_num">Data de Emissão</label>
        </div>
      </div>
      <div class="input-field col s12 m12">
        <button @click="prepareSubmitReservista" v-bind:disabled="verificaForm === false" class="btn right" type="button">SALVAR</button>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import {converteData, formataData} from '@/assets/js/form-utils.js'
import {CONFIG} from '@/config/config.js'
import SocialService from '@/services/social-service.js'
import { verificaData } from '@/assets/js/form-utils'
import sha1 from 'js-sha1'

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)

export default {
  name: 'Reservista',
  components: {
    'loading': Loading,
  },
  props: {
      doc: Object,
      pf_id: String
  },
  data (){
    return {
      loading_reservista: false,
      meta: this.$store.state.meta.data,
      reservista: {
        pf_res: this.doc.res,
        pf_res_emissao: (verificaData(this.doc.res_emissao, 'YYYY-MM-DD') === true ? converteData(this.doc.res_emissao) : null),
      },
      error_fields: {},
      loaded: null,      
    }
  },
  computed: {
    verificaForm: function() {
        let status = (
          Object.keys(this.reservista).filter((k) => this.reservista[k] && this.reservista[k] != '').length === 2
          && 
          (verificaData(this.reservista.pf_res_emissao) === true)
        )
        this.$emit('statusChange', {
          doc: 7,
          status: status
        })
        return status
    }
  },
  methods: {
    async submitInsertReservista(reservista){
      axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/res/`, {
        ...reservista,
        ...{
          'pf_id': this.pf_id,
          'device': await socialService.getDeviceInfo()
        }
      })
      .then((response) => {
        this.loading_reservista = false
        setTimeout(() => {
          this.initFields()
          this.$emit('docSaved', 6)
        }, 100)
      })
      .catch((error) => {
        M.toast({html: 'Não foi possível realizar esta operação...verifique a sua conexão com a internet e tente novamente!'})
        this.loading_reservista = false
        setTimeout(() => {
          this.initFields()
        }, 100)
      })
    },
    prepareSubmitReservista(){
      this.loading_reservista = true
      let a = this.reservista //Atual

      let titulo = {
        pf_id: this.pf_id,
        pf_res: this.reservista.pf_res,
        pf_res_emissao: (verificaData(this.reservista.pf_res_emissao, 'YYYY-MM-DD') === true ? formataData(this.reservista.pf_res_emissao) : null)
      }

      if(this.loaded !== sha1(JSON.stringify(titulo))){
        return this.submitInsertReservista(titulo)
      } else {
        this.loading_reservista = false
        this.$emit('docSaved', 6)
      }
    },
    initFields () {
      M.updateTextFields()
      M.FormSelect.init(document.querySelectorAll('select'))
    },
    verificaStatusDocumento(){
      return true //Não obrigatório
    }
  },
  mounted(){
    this.loaded = sha1(JSON.stringify({
      pf_id: this.pf_id,
      pf_res: this.reservista.pf_res,
      pf_res_emissao: (verificaData(this.reservista.pf_res_emissao, 'YYYY-MM-DD') === true ? formataData(this.reservista.pf_res_emissao) : null)
    }))

    this.initFields()
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/steps/documentos/Reservista.vue